import React from "react";
import ReactApexChart from "react-apexcharts";

// let colors = ["#f0f9ba", "#fff1ae", "#fed38c", "#feb669", "#f3854e"];
let colors = ["#1542E6", "#E63A15", "#59E615", "#fed38c"];

function generateDayWiseTimeSeries(baseval, count, yrange) {
  var i = 0;
  var series = [];
  while (i < count) {
    var x = baseval;
    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push([x, y]);
    baseval += 86400000;
    i++;
  }
  return series;
}

var data = generateDayWiseTimeSeries(new Date('2022-03-25').getTime(), 63, {
  min: 30,
  max: 90
})

//console.log('CAD PO', data);

export default class CChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    
    };

  }

  setMinMax = (min, max) => {
    this.props.setSelectionMinMax(min, max);
  };

  selectionEvent(e, chartContext) {

    let { xaxis, yaxis } = chartContext;
    this.setMinMax(xaxis.min, xaxis.max);

  }



  render() {

    const dates = this.props.ir_data.map(x => {
      
      return x[0];
    });

    const irData = this.props.ir_data.map(x => {
      return x[1];
    });

    const rfData = this.props.rf_data.map(x => {
      return x[1];
    });

    console.log('RFChart Dates', dates.length, irData.length, rfData.length);

    const opt = {
          
      seriesIrr: [{
        name: 'Rainfall (mm)',
        type: 'column',
        data: rfData
      }, {
        name: 'Irrigation Requirement (TMC)',
        type: 'line',
        data: irData
      }],

      optionsIrr: {
        chart: {
          id: 'irrchart4',
          height: 350,
          type: 'line',
          toolbar: {
            autoSelected: 'pan',
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          }
        },
        forecastDataPoints: {
          // count: 15,
          count: this.props.forecastdays,
        },
        stroke: {
          width: [0, 4],
          colors: ["#FF1654", "#247BA0"]
        },
        
        dataLabels: {
          enabled: false,
          // enabledOnSeries: [1]
        },
        labels: dates,
        // colors: ['#008FFB', 'green'],
        // colors: ['#008FFB', '#00e396'],
        colors: ["#FF1654", "#247BA0"],
        
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'dd MMM yy',
            }, 
          tooltip: {
            enabled: false
          },
          min: dates[0],
          max: dates[dates.length-1]
        },
        legend: {
          onItemClick: {
            toggleDataSeries: false
          },
        },

        yaxis: [{
          
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#FF1654'
          },
          labels: {
            style: {
              colors: '#FF1654',
            }
          },
          title: {
            text: "Rainfall (mm)",
            style: {
              color: '#FF1654',
            }
          },
          tooltip: {
            enabled: true
          },
        
        }, {
          opposite: true,
          title: {
            text: 'Irrigation Requirement (TMC)',
            offsetY: 15,
            style: {
              color: '#247BA0',
            }
          },
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#247BA0'
          },
          labels: {
            style: {
              colors: '#247BA0',
            }
          },
          tooltip: {
            enabled: true
          }
        }]
      },
    
      seriesLineIrr: [{
        name: 'Forecast Rainfall (mm)',
        data: this.props.rf_data
      }, {
        name: 'Irrigation Requirement Forecast (TMC)',
        data: this.props.ir_data
      }],
      optionsLineIrr: {
        chart: {
          id: 'irrchart3',
          type: 'area',
          brush:{
            target: 'irrchart4',
            enabled: true,
            // autoScaleYaxis: true
          },
          selection: {
            enabled: true,
            xaxis: {
              max: this.props.selection_max,
              min: this.props.selection_min,
            }
          }
        },
        // colors: ['#008FFB', '#00e396'],
        colors: ['#f695b6', '#438eae'],
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.91,
            opacityTo: 0.1,
          }
        },
        xaxis: {
          min: dates[0],
          max: dates[dates.length-1],
          type: 'datetime',
          labels: {
            format: 'dd MMM yy',
            }, 
          tooltip: {
            enabled: false
          }
        },
        legend: {
          position: 'top',
          fontSize: '12px',
          floating: true,
          onItemClick: {
            toggleDataSeries: false
          },
        },
        // legend: {
        //   show: true,
        //   position: 'top',
        //   onItemClick: {
        //     toggleDataSeries: false
        //   },
        //   onItemHover: {
        //     highlightDataSeries: false
        //   },

        // },
        yaxis: [{
          tickAmount: 2,        
        }, {
          opposite: true,
          tickAmount: 2,
        }]
      },
    
    
    };



    return (

      <div id="wrapper-irr" style={{height: '100%'}}>
        <div id="chart-line2-ir" style={{height: '60%'}}>
          <ReactApexChart 
            options={opt.optionsIrr} 
            series={opt.seriesIrr} 
            type="line" 
            height={'100%'}
            width={'95%'}  
          />
        </div>
        <div id="chart-line-ir" style={{height: '40%'}}>
          <ReactApexChart 
            options={opt.optionsLineIrr}
            series={opt.seriesLineIrr} 
            type="area" 
            height={'70%'} 
            width={'95%'} 
          />
        </div>
      </div>
      

      // <div id="chart" style={{height: '100%'}}>
      // <ReactApexChart 
      //   options={this.state.options} 
      //   series={this.state.series} 
      //   type="bar" 
      //   height={'90%'} 
      // />
      // </div>


    );
  }
  
}


